/* eslint-disable max-lines-per-function */
import React from 'react';
import styled from 'styled-components';
import defaultBackgroundDesktopImage from '../../json/images/landingPage/cloth.header.jpg';
import defaultBackgroundMobileImage from '../../json/images/landingPage/cloth.header.mobile.jpg';
import backgroundCurtainsDesktopImage from '../../json/images/landingPage/brands/madura.header.jpg';
import backgroundCurtainsMobileImage from '../../json/images/landingPage/brands/madura.header.mobile.jpg';
import maduraLogo from '../../assets/home/maduraLogo.png';
import {
  tabletThresholdPixels, Button,
} from '../home/v4/styledComponents';
import tilliLogo from '../../json/images/landingPage/tilli.logo.LP.png';

const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin: 64px auto 0;
  box-sizing: border-box;
  justify-content: center;
  gap: 64px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: calc(100vw - 40px);
    flex-direction: column;
    margin: 40px auto 0;
    gap: 24px;
  }
`;

const Title = styled.h1`
  font-size: 60px;
  font-weight: 700;
  letter-spacing: 6px;
  text-transform: uppercase;
  margin: 0;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 36px;
    letter-spacing: 4px;
  }
`;

const Content = styled.div`
  max-width: 460px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: ${tabletThresholdPixels}) {
    gap: 24px;
    max-width: 100%;
  }
`;

const StyledDiv = styled.div`
  margin-top: 25px;
  font-family: Space Mono;
  font-size: 16px;
`;

const CurtainsLogo = styled.img`
  margin-left: 10px;
  width: 140px;
`;

const Logos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  @media (max-width: ${tabletThresholdPixels}) {
    max-width: 250px;
    margin: 0 auto;
  }
`;

const BrandLogo = styled.img`
  max-height: 80px;
  max-width: 250px;
  object-fit: contain;
`;

const TilliLogo = styled.img`
  width: 90px;
`;

const BackgroundImageContainer = styled.div`
  @media (max-width: ${tabletThresholdPixels}) {
    display: flex;
    justify-content: center;
  }
`;

const BackgroundImage = styled.img`
  border-radius: 12px;
  width: 612px;
  height: 570px;
  object-fit: cover;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    max-width: 612px;
    height: unset;
  }
`;

const ButtonContainerDesktop = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 25px;
    gap: 25px;
  @media (max-width: ${tabletThresholdPixels}) {
    display: none;
  }
`;

const ButtonContainerMobile = styled.div`
    display: none;
  @media (max-width: ${tabletThresholdPixels}) {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
`;

interface HeaderPartnersProps {
  curtainsNote: boolean;
  photoVersion: string;
  backgroundImage: string;
  mobileBackgroundImage: string;
  onScrollToStep1: () => void;
  link: string;
  brandLogo: string;
  customText: string;
  title: string;
}

function HeaderPartners({
  curtainsNote, photoVersion, backgroundImage, mobileBackgroundImage, onScrollToStep1, link, brandLogo, customText,
  title,
}: HeaderPartnersProps) {
  const mobileSrc = photoVersion === 'curtains'
    ? backgroundCurtainsMobileImage
    : mobileBackgroundImage || defaultBackgroundMobileImage;

  const desktopSrc = photoVersion === 'curtains'
    ? backgroundCurtainsDesktopImage
    : backgroundImage || defaultBackgroundDesktopImage;

  const renderLogos = () => (
    <>
      {curtainsNote
        && (
          <Logos>
            <CurtainsLogo src={maduraLogo} />
            <TilliLogo src={tilliLogo} alt="logo Tilli" />
          </Logos>
        )}
      {brandLogo && (
        <div>
          {link ? (
          // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <a href={link} target="_blank" rel="noopener noreferrer">
              <BrandLogo src={brandLogo} />
              <TilliLogo src={tilliLogo} alt="logo Tilli" />
            </a>
          ) : (
            <Logos>
              <BrandLogo src={brandLogo} />
              <TilliLogo src={tilliLogo} alt="logo Tilli" />
            </Logos>
          )}
        </div>
      )}
    </>
  );

  return (
    <Container>
      <Content>
        <Title>{title || 'Faites durer vos produits !'}</Title>
        <StyledDiv>
          {customText ? (
            <span dangerouslySetInnerHTML={{ __html: customText }} />
          ) : (
            <span>
              Nous sommes fiers de nous associer à Tilli pour prendre soin de nos produits et les faire perdurer.
              Notre partenaire fait appel
              {' '}
              <b>aux meilleurs artisans couturiers et brodeurs</b>
              {' '}
              pour
              {' '}
              <b>réparer, ajuster et entretenir</b>
              {' '}
              vos pièces favorites.
            </span>
          )}
        </StyledDiv>
        <ButtonContainerDesktop>
          <Button dark onClick={onScrollToStep1}>Réaliser un devis</Button>
          {renderLogos()}
        </ButtonContainerDesktop>
      </Content>
      <BackgroundImageContainer>
        <picture>
          <source
            media={`(max-width: ${tabletThresholdPixels})`}
            srcSet={mobileSrc}
          />
          <BackgroundImage
            src={desktopSrc}
            alt=""
          />
        </picture>
      </BackgroundImageContainer>
      <ButtonContainerMobile>
        <Button dark onClick={onScrollToStep1}>Réaliser un devis</Button>
        {renderLogos()}
      </ButtonContainerMobile>
    </Container>
  );
}

export default HeaderPartners;
